import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyD4rMtccqJk6QJEFwjJ_fCHTLnmOO2EqIo",
  authDomain: "kulu-zrkebo.firebaseapp.com",
  projectId: "kulu-zrkebo",
  storageBucket: "kulu-zrkebo.firebasestorage.app",
  messagingSenderId: "1075905297816",
  appId: "1:1075905297816:web:c31c9187e41eb973ed3fed",
  measurementId: "G-VNJLH942Y9"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export default app;
